angular.
module("dx.webapp.importStudents").
constant("DX_IMPORT_STUDENTS_ACCESSIBILITY_CODE",
	Object.freeze({
		TEXT_TO_SPEECH: "T",
		AUDIO_FILES: "A",
		EXTENDED_TIME: "X",
		SPELLCHECK: "S",
		IMMERSIVE_READER: "I",
	})
);
